module.exports = __webpack_public_path__ + "static/media/abzug_lampe_grün.a5780fba.jpg";